import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";
import {customAsyncComponent} from "@/functions/customAsyncComponent";
import {WorkspaceId} from "@/sdk.ts";
import {RouteLocationRaw, Router, RouteRecordRaw} from "vue-router";

export namespace BootcampUpdateRoute {
  export function record(): RouteRecordRaw {
    return {
      name: 'bootcamp_update',
      path: '/workspace/:workspaceId/bootcamps/:bootcampId',
      component: customAsyncComponent(async () => import('./views/BootcampUpdateView.vue')),
      meta: {
        hasNav: true,
        requiresAuth: true,
        //requiresAdmin: true,
        localeCategories: [
          LOCALE_CATEGORIES.BOOTCAMP
        ],
        pageHeader: {
          showHome: false,
          showTitle: false,
          title: '',
          breadcrumb: []
        }
      },
    }
  }

  export function location(workspaceId: number, bootcampId: string): RouteLocationRaw {
    return {name: 'bootcamp_update', params: {workspaceId, bootcampId}};
  }

  export function getParams(router: Router): { workspaceId: WorkspaceId; bootcampId: string } {
    return {
      workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
      bootcampId: router.currentRoute.value.params.bootcampId as string,
    }
  }
}

export function getBootcampUpdateRouteLocation(workspaceId: number, bootcampId: string): RouteLocationRaw {
  return {name: 'bootcamp_update', params: {workspaceId, bootcampId}};
}

export function getBootcampUpdateRouteParams(router: Router): { workspaceId: WorkspaceId; bootcampId: string } {
  return {
    workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
    bootcampId: router.currentRoute.value.params.bootcampId as string,
  }
}